import type { WidgetDataResponse } from '../types';

/** Maps GET /api/v1/widget/:id response to SET_DATA payload (sponsor merge matches App initial load). */
export function buildSetDataPayloadFromWidgetResponse(res: WidgetDataResponse) {
  const feeStructuresRaw = res.data.fee_structures || [];
  const sponsorsList = res.data.sponsors || [];
  const feeStructures = feeStructuresRaw.map((tier: any) => {
    const hasSponsorOnTier = tier.sponsor && (tier.sponsor.sponsor_video || tier.sponsor.sponsor_video_thumbnail);
    if (hasSponsorOnTier) return tier;
    const matched = sponsorsList.find(
      (s: any) =>
        (s.tier && (s.tier === tier._id || s.tier === tier.id)) ||
        (s.fee_structure && (s.fee_structure === tier._id || s.fee_structure === tier.id)),
    );
    return matched ? { ...tier, sponsor: matched } : tier;
  });
  return {
    widget: res.data.widget,
    event: res.data.event,
    feeStructures,
    sponsors: sponsorsList,
    venue: res.data.venue,
    venueConfig: res.data.venue_config,
    seatStatus: res.data.seat_status,
    stripePublishableKey: res.data.stripe_publishable_key || res.data.payment_rail?.stripe_publishable_key || '',
    paymentRail: res.data.payment_rail ?? null,
  };
}
